import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { Point, Sprite, Graphics, Text , Texture, BLEND_MODES } from "pixi.js";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { TimelineMax, Power2, TweenLite, Power3 } from "gsap";
import { ResizeHelper , IDimConfig } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { PunkCounter } from "../countup/PunkCounter";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { FontWeight, FontStyle } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { TranslationConfig } from "../../../translations/TranslationConfig";
import { SoundConfig } from "../../../SoundConfig";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { WinCounter } from "../countup/WinCounter";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class PosterStates extends StateHandler{
    // POSTER
    public static readonly POLICE:string = "Police";
    public static readonly RESPIN:string = "Poster_Riot";
    public static readonly BONUS:string = "Poster_Anarchy";
    public static readonly BONUS2:string = "Poster_Civil_War";
    public static readonly BIG_WIN:string = "Poster_Bigwin";
    public static readonly SUPER_WIN:string = "Poster_Superwin";
    public static readonly EPIC_WIN:string = "Poster_Epicwin";
    public static readonly WICKED_WIN:string = "Poster_Wickedwin";

    // RETRIGGER
    public static readonly RETRIGGER:string = "Retrigger";
    public static readonly RETRIGGER1:string = "Retrigger_1";
    public static readonly RETRIGGER2:string = "Retrigger_2";
    public static readonly RETRIGGER3:string = "Retrigger_3";

    // NOWIN
    public static readonly NO_WIN:string = "No_Win";
    public static readonly BOLLOCKS:string = "Bollocks";
    public static readonly MIND_THE_GAP:string = "Mind_The_Gap";
    public static readonly QUEEN:string = "Queen";
    public static readonly QUEEN2:string = "Queen_2";
    public static readonly SHIT_GAME:string = "Shit_Game";

    public get isBigWin():boolean{
        return (this.equal(PosterStates.BIG_WIN) ||
         this.equal(PosterStates.SUPER_WIN) ||
         this.equal(PosterStates.EPIC_WIN) ||
         this.equal(PosterStates.WICKED_WIN))
    }

    public get animName():string{
        switch(this.state){
            case PosterStates.RESPIN:
            case PosterStates.BONUS:
                return "intro";
            case PosterStates.BOLLOCKS:
            case PosterStates.MIND_THE_GAP:
            case PosterStates.QUEEN:
            case PosterStates.QUEEN2:
            case PosterStates.SHIT_GAME:
                return this.state;
            default:
                return "intro";
        }
    }

    public get soundNoWinName():string{
        switch(this.state){
            case PosterStates.QUEEN:
                return SoundConfig.instance.NO_WIN_POSTER_NO_WIN;
            case PosterStates.SHIT_GAME:
                return SoundConfig.instance.NO_WIN_POSTER_SHIT;
            case PosterStates.BOLLOCKS:
                return SoundConfig.instance.NO_WIN_POSTER_BULLOCKS;
            default:
                return SoundConfig.instance.NO_WIN_POSTER_SHIT;
        }
    }

    public get gradientColor():string{
        switch(this.state){
            case PosterStates.BIG_WIN:
                return "rgb(0,51,255,0.7)";
            case PosterStates.SUPER_WIN:
                return "rgb(44,168,22,0.7)";
            case PosterStates.EPIC_WIN:
                return "rgb(204,0,0,0.7)";
            case PosterStates.WICKED_WIN:
                return "rgb(153,0,255,0.7)";
            default:
                return "rgb(0,0,0,0.7)"
        }
    }
}

export class PosterManager extends BaseView {

    private readonly DEFAULT_TEXT_STYLE:TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 10,
        dropShadowDistance: 2,
        fontFamily : "Open Sans",
        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.EXTRA_BOLD,
        fontSize: 68,
        fill: [
            "white",
            // "#fffb00",
            // "#ff9300"
        ]
    };

    private static _instance:PosterManager;
    protected state:PosterStates = new PosterStates();

    protected posterSp:Sprite;
    protected sourcePath:string = "Feature_Poster/"
    protected blackGraphics:Graphics;
    protected gradientOverlay:Sprite;

    protected gradientSupported:boolean = true;

    protected fireSequence:Sequence;
    
    protected totalWinText:Text;
    protected counter:PunkCounter;

    protected spineSireneAnimation:PIXI.spine.Spine;
    protected spinePosterAnimation:PIXI.spine.Spine;

    protected timeline:TimelineMax;
    protected loopTimeline:TimelineMax;
    private _onClickCB:Function

    protected PosterDim:IDimConfig = {
        dimOrientation : {
            landscape :{
                scale:      new Point( 1, 1),
                position:   new Point( 640, 300),
                layout :{
                    left:   new Point( 640, 300),
                    right:  new Point( 640, 300)
                }
            },
            portrait :{ 
                scale:      new Point( 1.25, 1.25),
                position:   new Point( 450, 220)
            }
        },
        WIDTH: 1440,
        HEIGHT: 720,
    };

    public bigWinTypeLvl(lvl:number):string{
        return [PosterStates.BIG_WIN,PosterStates.SUPER_WIN,PosterStates.EPIC_WIN,PosterStates.WICKED_WIN][Math.min(lvl,3)];
    }

    public static get instance():PosterManager{
        return this._instance;
    }

    constructor(){ super() 
        if(PosterManager._instance) {
            debugger;
            throw new Error("Error: Currency.constructor() - Instantiation failed: Singleton.");
        }else{
            PosterManager._instance = this;
            StageManager.getLayer(PunkGameConfig.instance.LAYERS.POSTER.name).addChild(this);
        }
    };

    protected initAnimations():void{
        this.blackGraphics = new Graphics();
        this.blackGraphics.alpha = 0;
        this._onClickCB = () => EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP));
        this.blackGraphics.interactive = false;
        this.blackGraphics.buttonMode = false;
        this.blackGraphics.on('pointerdown', () => this._onClickCB());
        this.totalWinText = this.createText(Translation.translate(TranslationConfig.TOTAL_WIN), this.DEFAULT_TEXT_STYLE );
        this.totalWinText.position.set(0,-120);
        this.spinePosterAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(PosterStates.RESPIN));
        this.spineSireneAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(PosterStates.POLICE));
        
        try{
            this.gradientOverlay = new Sprite(this.createGradTexture());
            this.gradientOverlay.anchor.set(0.5,0.5);
            this.gradientOverlay.rotation = MathHelper.degreeToAngle(90);
            this.gradientOverlay.alpha = 0;
        }
        catch{
            this.gradientSupported = false;
        }

        this.fireSequence = Sequence.createSequence(GameResources.getTextures("BigWinFire"));
        this.fireSequence.blendMode = BLEND_MODES.ADD;
        this.fireSequence.position.y = 60;
        
        this.spineSireneAnimation.visible = false;
        this.spinePosterAnimation.visible = false;
        this.defineZindexAndAdd()
    }

    private defineZindexAndAdd():void{

        const zChange = this.gradientSupported ? 0 : -1;

        this.blackGraphics.zIndex = 0;
        if(this.gradientSupported) this.gradientOverlay.zIndex = 1;
        this.fireSequence.zIndex = 2 + zChange;
        this.spinePosterAnimation.zIndex = 3+ zChange;
        this.spineSireneAnimation.zIndex = 4+ zChange;
        this.totalWinText.zIndex = 5+ zChange;

        this.addChild(this.blackGraphics);
        if(this.gradientSupported) this.addChild(this.gradientOverlay);
        this.addChild(this.fireSequence);
        this.addChild(this.spinePosterAnimation);
        this.addChild(this.spineSireneAnimation);
        this.addChild(this.totalWinText);
    }

    private createText(text:string, style:TextStyleOptions):Text {
        const textField = new PIXI.Text(text, style);
        textField.style.align = "center";
        textField.anchor.set(0.5, 0.5);
        textField.alpha = 0;
        return textField;
    }

    private changeSpine(spine:PIXI.spine.Spine):PIXI.spine.Spine{
        const indx:number = spine.zIndex;
        this.getChildAt(indx).destroy();
        spine = new PIXI.spine.Spine(GameResources.getSpineAsset(this.state.state));
        spine.visible = false;
        spine.zIndex = indx;
        this.addChild(spine);
        return spine;
    }
    
    public addChild<TChildren extends PIXI.DisplayObject[]>(...child: TChildren): TChildren[0]{
        super.addChild(...child);
        this.sortChildren();
        return child[0];
    }

    public playSirene(active:boolean,level:number= 0):TimelineMax{
        this.loopTimeline = Helper.timeLineKiller(this.loopTimeline);
        this.loopTimeline = new TimelineMax();

        if(active){
            this.state.set(PosterStates.POLICE);
            this.spineSireneAnimation = this.changeSpine(this.spineSireneAnimation);
            const trackName:string = level == 0 ? "PoliceFS_Loop_A" : "PoliceFS_Loop_B";
            this.spineSireneAnimation.alpha = 1;
            this.spineSireneAnimation.state.timeScale = 1;
            this.loopTimeline.add(() => this.spineSireneAnimation.visible = true)
            this.loopTimeline.add(() => this.spineSireneAnimation.state.setAnimation(0,trackName,true))

            const pivY:number = ResizeHelper.IsLandscape() ? 60 : 30;
            this.spineSireneAnimation.pivot.set(0,-pivY);
        }else if(this.spineSireneAnimation.visible){
            this.loopTimeline.to(this.spineSireneAnimation,0.35,{alpha:0,ease: Power2.easeOut});
            this.loopTimeline.add(() => this.spineSireneAnimation.state.clearTracks());
            this.loopTimeline.add(() => this.spineSireneAnimation.visible = false);
        }
        return this.loopTimeline;
    }

    public playNoWinPoster(state:string):void{
        this.state.set(PosterStates.NO_WIN);
        this.spinePosterAnimation = this.changeSpine(this.spinePosterAnimation);

        this.state.set(state);
        SoundManager.playSoundEffect(this.state.soundNoWinName);

        this.spinePosterAnimation.visible = true;
        this.spinePosterAnimation.alpha = 1;
        this.spinePosterAnimation.state.setAnimation(0,this.state.animName,false);
    }

    public playFSRetrigger(state:string):void{
        SoundManager.playSoundEffect(SoundConfig.instance.FS_EXTRASPINS_ADDED);
        this.state.set(PosterStates.RETRIGGER);
        this.spinePosterAnimation = this.changeSpine(this.spinePosterAnimation);
        this.spinePosterAnimation.visible = true;
        this.spinePosterAnimation.alpha = 1;
        this.spinePosterAnimation.state.setAnimation(0,state,false);
    }

    public playPoster(state:string):TimelineMax{
        this.timeline = Helper.timeLineKiller(this.timeline);
        this.timeline = new TimelineMax();
        this.state.set(state);
        this.spinePosterAnimation = this.changeSpine(this.spinePosterAnimation);

        const spineDurr:number = this.state.equal(PosterStates.RESPIN) ? 1.5 : 2;
        this.timeline.fromTo(this.blackGraphics,0.2,{alpha:0},{alpha:0.6},0)
        this.timeline.add(() => this.spinePosterAnimation.visible = true,0)
        this.timeline.add(() => this.spinePosterAnimation.state.setAnimation(0,this.state.animName,false),0);
        this.timeline.to(this.spinePosterAnimation,spineDurr,{alpha:1})
        this.timeline.to(this.blackGraphics,0.3,{alpha:0},"-="+0.3)
        this.timeline.play();
        return this.timeline;
    }

    public startBigwin(state:string):void{
        this.state.set(state);
        this.spinePosterAnimation = this.changeSpine(this.spinePosterAnimation);
        if(this.gradientSupported) this.gradientOverlay.texture = this.createGradTexture();

        const loopTrack:string = state == PosterStates.WICKED_WIN ? "Loop_2" : "Loop";
        const artemHack:string = state == PosterStates.SUPER_WIN ? "LevelUp" : "Level_Up";

        this.spinePosterAnimation.visible = true,
        this.spinePosterAnimation.stateData.setMix(loopTrack, "Outro", 0.4);
        this.spinePosterAnimation.stateData.setMix(loopTrack,artemHack, 0.4);
        this.spinePosterAnimation.state.setAnimation(0, "Intro", false);
        this.spinePosterAnimation.state.addAnimation(0, loopTrack, true, 0);

        if(this.gradientSupported) TweenLite.fromTo(this.gradientOverlay,0.3,{alpha:0},{alpha:1});
        
        if(state == PosterStates.BIG_WIN){
            this.loopTimeline = Helper.timeLineKiller(this.timeline)
            this.loopTimeline = new TimelineMax({
                repeat: -1,
                repeatDelay: 0,
                onStart:() => this.fireSequence.alpha = 1
            })
            this.loopTimeline.add(this.fireSequence.playAnimation());
        }
    }

    public lvlUp(lastEnd:boolean = false):void{
        const artemHack:string = this.state.equal(PosterStates.SUPER_WIN) ? "LevelUp" : "Level_Up";
        this.spinePosterAnimation.state.setAnimation(0, artemHack, false);
        if(this.gradientSupported) TweenLite.fromTo(this.gradientOverlay,0.3,{alpha:1},{alpha:0, ease:Power3.easeOut});
        if(lastEnd) TweenLite.fromTo(this.fireSequence,0.8,{alpha:1}, {alpha:0}).eventCallback("onComplete",() => Helper.timeLineKiller(this.loopTimeline));
    }

    public endBigWin(lastEnd:boolean = false):void{
        this.spinePosterAnimation.state.setAnimation(0, 'Outro', false);
        if(this.gradientSupported) TweenLite.fromTo(this.gradientOverlay,0.3,{alpha:1},{alpha:0, ease:Power3.easeOut});
        if(lastEnd) TweenLite.fromTo(this.fireSequence,0.8,{alpha:1}, {alpha:0}).eventCallback("onComplete",() => Helper.timeLineKiller(this.loopTimeline));
    }

    public setInteractive(value:boolean){
        this.blackGraphics.interactive = value;
        this.blackGraphics.buttonMode = value;
        this.buttonMode = value;
        this.interactive = value;
    }

    protected createGradTexture():Texture {
        // adjust it if somehow you need better quality for very very big images
        const quality = 126;
        const canvas = document.createElement('canvas');
        canvas.width = quality;
        canvas.height = 1;
    
        const ctx = canvas.getContext('2d');
    
        // use canvas2d API to create gradient
        const grd = ctx!.createLinearGradient(0, 0, quality, 0);
        grd.addColorStop(0.5, this.state.gradientColor);
        grd.addColorStop(1, 'black');
    
        ctx!.fillStyle = grd;
        ctx!.fillRect(0, 0, quality, 1);
    
        return PIXI.Texture.from(canvas);
    }

    public killBigWin():void{
        this.spinePosterAnimation.visible = false;
        this.spinePosterAnimation.state.setEmptyAnimation(0,0);
    }

    public playTotalWin(value:number, winBelowStake:boolean):TimelineMax{
        const tl:TimelineMax = new TimelineMax();
        this.totalWinText.text = Translation.translate(TranslationConfig.TOTAL_WIN);// + "    " + Currency.formatValue(value);
        while(this.totalWinText.width > 500) this.totalWinText.style.fontSize--;

        tl.add(() => WinCounter.winWayCounter.playTotalWin(value))
        tl.fromTo(this.blackGraphics,0.2,{alpha:0},{alpha:0.6})
        if(!winBelowStake) {
            tl.fromTo(this.totalWinText,0.2,{alpha:0},{alpha:1})
        }
        tl.to(this,2,{})
        tl.to(this.totalWinText,0.5,{alpha:0})
        tl.to(this.blackGraphics,0.3,{alpha:0},"-=0.3")
        tl.play();
        return tl;
    }

    protected onResize(){
        this.position = new Point(360,360);
        if(this.blackGraphics === undefined) return;
        this.blackGraphics.clear();
        this.blackGraphics.beginFill( 0x000000, 1);
        this.blackGraphics.drawRect(-this.PosterDim.WIDTH*0.5,-this.PosterDim.HEIGHT*0.5,this.PosterDim.WIDTH, this.PosterDim.HEIGHT);
        this.blackGraphics.endFill();

        const pivYG:number = ResizeHelper.IsLandscape() ? 0 : 0;

        // const pivY:number = ResizeHelper.IsLandscape() ? 70 : 30;
        const w:number = (ResizeHelper.IsLandscape() ? this.PosterDim.HEIGHT : this.PosterDim.WIDTH);
        const h:number = (ResizeHelper.IsLandscape() ? this.PosterDim.WIDTH : this.PosterDim.HEIGHT);

        if(this.gradientSupported){
            this.gradientOverlay.width = w;
            this.gradientOverlay.height = h;            
        }
        ResizeHelper.IsLandscape() ? this.fireSequence.scale.set(4,2) : this.fireSequence.scale.set(2,4);
        // ResizeHelper.IsLandscape() ? this.fireSequence.scale.set(4,2) : this.fireSequence.scale.set(1,1);

        if(this.gradientSupported) this.gradientOverlay.position.set(0,pivYG)
        this.spinePosterAnimation.pivot.set(0,-pivYG);
        this.spineSireneAnimation.pivot.set(0,-pivYG);
    }
}